export default {
      id: "icon-phone1-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-phone1",
      toString: function () {
        return this.url;
      }
    }